import { combineReducers } from 'redux'
import { formReducer, modelReducer } from 'react-redux-form'

import gameboard from './early/gameboard'
import interestActivity from './early/interestActivity'
import backpack from './early/backpack'
import avatar from './early/avatar'
import tools from './early/tools'
import budget from './early/budget'
import elements from './early/elements'
import search from './early/search'
import presentation from './early/presentation'
import audio from './early/audio'
import earlyListing from './early/earlyListing'
import occupationProfile from './early/occupationProfile'

const initialNoteForm = {
  reflection: ''
}
const early = combineReducers({
  audio,
  backpack,
  gameboard,
  interestActivity,
  avatar,
  tools,
  budget,
  search,
  presentation,
  elements,
  earlyListing,
  occupationProfile,
  promotionReflection: modelReducer('early.promotionReflection', initialNoteForm),
  forms: formReducer('early', {
    promotionReflection: initialNoteForm
  })
})

export default early
